// Centralized structured data. The Organization schema matters extra here:
// "Tare Labs" collides in search with Tare scales, Tare Inc., TARA Tech, etc.
// Explicit Organization + founder + location helps Google and AI answer
// engines resolve the right entity.

const SITE_URL = 'https://tarelabs.com';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#organization`,
  name: 'Tare Labs',
  url: SITE_URL,
  logo: `${SITE_URL}/t.png`,
  image: `${SITE_URL}/og-image.jpg`,
  description:
    'Integration and AI automation consultancy for logistics and eCommerce companies. EDI modernization, iPaaS integration, agentic AI, and fractional solutions architecture.',
  founder: {
    '@type': 'Person',
    name: 'Dan Ackley',
    jobTitle: 'Founder & Principal Solutions Architect',
    description:
      'Solutions architect with 13+ years across Amazon, Flexport, and UPS specializing in EDI, B2B integration, and AI automation.',
    sameAs: ['https://www.linkedin.com/in/dan-ackley-5931a8125/'],
  },
  areaServed: 'US',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Nashville',
    addressRegion: 'TN',
    addressCountry: 'US',
  },
  knowsAbout: [
    'EDI integration',
    'B2B integration',
    'iPaaS',
    'Amazon Vendor Central',
    'Supply chain technology',
    'Agentic AI',
    'Logistics technology',
  ],
  sameAs: [
    'https://www.linkedin.com/company/tarelabs',
    'https://www.linkedin.com/in/dan-ackley-5931a8125/',
  ],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Tare Labs',
  publisher: { '@id': `${SITE_URL}/#organization` },
};

// Builds BlogPosting schema from a post record in blogPosts.js
export function buildBlogPostingSchema(post) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.excerpt,
    datePublished: post.date,
    dateModified: post.date,
    // Single-author blog; visible byline ("Dan @ Tare Labs") stays as-is,
    // but the schema uses the full name for entity disambiguation.
    author: {
      '@type': 'Person',
      name: 'Dan Ackley',
      sameAs: ['https://www.linkedin.com/in/dan-ackley-5931a8125/'],
    },
    publisher: {
      '@type': 'Organization',
      name: 'Tare Labs',
      logo: { '@type': 'ImageObject', url: `${SITE_URL}/t.png` },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/blog/${post.id}`,
    },
    articleSection: post.category,
  };
}
